// extracted by mini-css-extract-plugin
export var button = "_h8-0";
export var donut = "_h8-1";
export var donutFill = "_h8-3";
export var donutTrack = "_h8-2";